import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function LinkSecondaryButton({ children, to, className = '' }) {
  return (
    <motion.div
      whileHover={{ scale: 1.03, y: -2 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`inline-flex ${className}`}
    >
      <Link
        to={to}
        className="inline-flex items-center justify-center gap-2 px-8 py-4 font-bold text-base rounded-2xl no-underline"
        style={{
          background: '#ffffff',
          color: '#1e293b',
          border: '2px solid #e2e8f0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
      >
        {children}
      </Link>
    </motion.div>
  );
}